









import { Component, Vue, Prop } from 'vue-property-decorator'
import AddOrRemove from '@/apps/open/components/AddOrRemove'
import { ElForm } from 'element-ui/types/form'
import store from '@/apps/open/store'
import { priUrlReg } from '@/apps/open/constants'

const PAUTH_CALLBACK_COUNT_LIMIT = 20 // 最多设置20个回调地址

@Component({
  componentName: 'EditPauthCallbackDialogBody',
  components: {
    AddOrRemove
  }
})
export default class EditPauthCallbackDialogBody extends Vue {
  @Prop()
  callbackList?: string[]

  @Prop()
  isSandbox!: boolean

  @Prop()
  submit!: Function

  $refs!: {
    form: ElForm
  }

  form = {
    callbackList: this.callbackList ? [...this.callbackList] : []
  }

  get isPrivate () {
    return store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调地址' } : { type: 'url', message: '请输入正确的回调地址' }
    const rules = [
      { required: true, message: '请输入回调地址' },
      urlRule
    ] as any
    if (!this.isSandbox) {
      rules.push({ pattern: /^(https|http):\/\//, message: '请输入https://开头的回调地址' })
    }
    return rules
  }

  get addAble () {
    return this.form.callbackList.length < PAUTH_CALLBACK_COUNT_LIMIT
  }

  addItem () {
    this.form.callbackList.push('')
  }

  removeItem (index: number) {
    this.form.callbackList.splice(index, 1)
  }

  onOk () {
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.submit(this.form.callbackList)
      }
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
  }
}
